import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import { TranslateService } from '@ngx-translate/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Console } from 'console';
import { WordcountService } from '../../../../wordcount.service';

declare var decimalInput: any;

@Component({
  selector: 'app-email',
  templateUrl: './email.html',
  styleUrls: ['./email.scss']
})

export class Email implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public editTo = false;
  public toStr = "";
  public editSubject = false;
  public subjectStr = "";
  public emailStr = "";
  public showAttachments = false;
  public jsonFile: any;
  public filename: any;
  public ckeConfig: any;
  public previewSrc: any = "";
  public previewSrcExtension = "";
  public attachment = false;
  public attachmentExt = "";
  public emailWords = 0;

  private loadAnswersSubscription: Subscription;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    public sanitizer: DomSanitizer,
    private http: HttpClient,
    public wordCount: WordcountService
  ) {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if (exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== "") {
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ]
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,ExportPdf';

    this.loadAnswersSubscription = this.dataSvc.getLoadEmailAnswersEvent().subscribe(() => {
      this.loadAnswers();
    });
  }
  
  resetVariables(){
    this.editTo = false;
    this.toStr = "";
    this.editSubject = false;
    this.subjectStr = "";
    this.emailStr = "";
    this.showAttachments = false;
    this.previewSrc = "";
    this.previewSrcExtension = "";
    this.attachment = false;
    this.attachmentExt = "";
  }
  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    this.resetVariables();
    if (this.dataSvc.currentQuestion().Question.QuestionType !== 1023) return;

    clearInterval();
    //GET METADATA OF EMAIL QUESTION
    //BASED ON CREATION USES SPLITS AND SUBSTRING TO GET THE DATA IN THE FORMAT THAT IT NEEDS
    var emailQuestion = this.dataSvc.currentQuestion().Question;
    if (emailQuestion !== null && emailQuestion !== undefined) {
      //INITIATE WORD COUNT LOGIC
      if (emailQuestion.Question.WordCount !== null && emailQuestion.Question.WordCount !== undefined
        && emailQuestion.Question.WordCount > 0) {
        this.wordCount.wordcount = emailQuestion.Question.WordCount;
        // setInterval(() => {
        //   this.wordCount.userWords = this.dataSvc.countEmailAnswersWords();
        // }, 1000);
      }

      var emailData = emailQuestion.Question.Metadata.toString();
      if (emailData !== null && emailData !== undefined && emailData !== "") {

        //POPULATES TO INPUT FIELD, IF POPULATED FROM METADATA CANDIDATE CANNOT EDIT
        if (emailData.indexOf("###To:") > -1) {
          this.editTo = false;
          var first = emailData.indexOf("###To:") + 6;
          var last = emailData.lastIndexOf("###");
          this.toStr = emailData.substring(first, last);
        }
        else {
          this.editTo = true;
        }

        //POPULATES SUBJECT FIELD, IF POPULATED FROM METADATA CANDIDATE CANNOT EDIT
        if (emailData.indexOf("$$$Subject:") > -1) {
          this.editSubject = false;
          var first = emailData.indexOf("$$$Subject:") + 11;
          var last = emailData.lastIndexOf("$$$");
          this.subjectStr = emailData.substring(first, last);
        }
        else {
          this.editSubject = true;
        }

        //DETERMINES WHETHER ATTACHMENTS CAN BE UPLOADED
        //NEED TO BE ABLE TO WRITE ATTACHMENTS TO MEDIA FILE - STILL TO DO
        if (emailData.indexOf("£££No£££") > -1) {
          this.showAttachments = false;
        }
        else {
          this.showAttachments = true;
        }

        //READ IN THE ANSWER FROM RESULTS AREA
        var answer = this.dataSvc.currentQuestion().Result.Selection;
        if (answer.indexOf("###To:") > -1) {
          var first = answer.indexOf("###To:");
          var last = answer.lastIndexOf("###") + 3;

          var toAnswer1 = answer.indexOf("###To:") + 6;
          var toAnswer2 = answer.lastIndexOf("###");
          this.toStr = answer.substring(toAnswer1, toAnswer2);

          var replaceTxt = answer.substring(first, last);
          answer = answer.replace(replaceTxt, "");
        }
        if (answer.indexOf("$$$Subject:") > -1) {
          var first = answer.indexOf("$$$Subject:");
          var last = answer.lastIndexOf("$$$") + 3;

          var subAnswer1 = answer.indexOf("$$$Subject:") + 11;
          var subAnswer2 = answer.lastIndexOf("$$$");
          this.subjectStr = answer.substring(subAnswer1, subAnswer2);

          var replaceTxt = answer.substring(first, last);
          answer = answer.replace(replaceTxt, "");
        }
        if (answer.indexOf("|||Attachment:") > -1) {
          var first = answer.indexOf("|||Attachment:");
          var last = answer.lastIndexOf("|||") + 3;

          var attAnswer1 = answer.indexOf("|||Attachment:") + 14;
          var attAnswer2 = answer.lastIndexOf("|||");
          var attachmentTxt = answer.substring(attAnswer1, attAnswer2).split("|");

          this.attachment = attachmentTxt[0] == "1" ? true : false;
          this.attachmentExt = attachmentTxt[1];

          var replaceTxt = answer.substring(first, last);
          answer = answer.replace(replaceTxt, "");

          if (this.attachment)
            setTimeout(() => this.updatePreviewSrc(), 200);
        }
        this.emailStr = answer;
      }
    }
  }

  //LOAD FILE FROM DEVICE AND ATTEMPT TO READ JSON AND FILENAME
  loadFileFromDevice(event) {
    if (this.showAttachments) {
      const file = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.jsonFile = reader.result.toString();
        this.filename = file.name;
        this.attachmentExt = this.filename.split('.').pop().toLowerCase()
      }
      reader.onerror = (error) => {
        //handle errors
        alert("Sorry file could not be uploaded. Please try again");
      };
    }
  }

  //SEND THE EMAIL, IT UPDATES QUESTION RESPONSE AND SAVES THE FILE TO MEDIA JSON FILE IF IT EXISTS
  sendEmail() {
    this.uploadAttachment();
    this.saveQuestion();
    if (this.dataSvc.currentExam().CurrentQuestion != (this.dataSvc.currentExam().Questions.length - 1)) {
      this.dataSvc.nextQuestion();
    }
    alert('Thank you, your email has been sent. / Bedankt, uw e-mail is verzonden.');
  }

  updateQuestion(evt) {    
    this.saveQuestion();    
  }

  saveQuestion() {
    var answer = "###To:" + this.toStr + "###" + "$$$Subject:" + this.subjectStr + "$$$" + "|||Attachment:" + (this.attachment ? "1" : "0") + "|" + this.attachmentExt + "|||" + this.emailStr;
    this.dataSvc.currentQuestion().Result.Selection = answer;
    setTimeout(() => {
      this.validateEmailWords(this.emailStr);
    }, 100);
    
  }

  validateEmailWords(data){
    try { 
      if (this.wordCount.wordcount === undefined || this.wordCount.wordcount === null) {
        var spwc = (<HTMLSpanElement>document.getElementById("spWc"));
        if (spwc !== null && spwc !== undefined) {
          this.wordCount.wordcount = parseInt(spwc.innerHTML);
        }
      }
      var spWarning = (<HTMLSpanElement>document.getElementById("spWarning"));
      if (this.wordCount.wordcount !== undefined) {
        this.emailWords = data.replace(/<[^>]*>?/gm, '').split(/\s/g).filter(element => {
          if(element === ""){
            return false;
          }else{
            return true;
          }          
        }).length;

        var divWordCount = document.getElementById("divWordCount");
        var exceeded = this.emailWords >= this.wordCount.wordcount;  
        if (divWordCount !== undefined) {
          divWordCount.style.display = "block";
          divWordCount.style.color = exceeded ? "red" : "inherit";
          divWordCount.style.fontWeight = exceeded ? "bold" : "normal";
          if (spWarning !== null && spWarning !== undefined) {
            spWarning.style.display = exceeded ? "block" : "none";
          }
        }
      }
    } catch(e) {
      
    }
  }

  uploadAttachment() {
    if (this.jsonFile !== null && this.jsonFile !== undefined && this.jsonFile !== "") {
      this.attachment = true;
      this.dataSvc.submitAttachment(this.dataSvc.currentQuestion().Question.Question.QuestionID, this.attachmentExt, this.jsonFile);
      this.updatePreviewSrc();
    }
  }

  updatePreviewSrc() {
    this.previewSrc = this.dataSvc.blobUrl + "/" + this.dataSvc.assessBlobContainer + "/SessionFiles/Exam/" + this.dataSvc.currentExam().Session.SessionId
      + "/" + this.dataSvc.currentQuestion().Question.Question.QuestionID + "/attachment." + this.attachmentExt;
    this.previewSrcExtension = "./assets/ext/" + this.getPreviewExtension() + ".png";

    document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
    document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
  }

  getPreviewExtension() {
    var fileExtension = this.attachmentExt;
    var extension = "";
    switch (fileExtension) {
      case "doc":
      case "docx":
        extension = "doc";
        break;
      case "xls":
      case "xlsx":
        extension = "xls";
        break;
      case "pdf":
        extension = "pdf";
        break;
      case "jpg":
      case "jpeg":
        extension = "jpg";
        break;
      case "mp3":
        extension = "mp3";
        break;
      case "gif":
        extension = "gif";
        break;
      case "zip":
        extension = "zip";
        break;
      case "txt":
        extension = "txt";
        break;
      default:
        extension = "file";
        break;
    }

    return extension;
  }

  openAttachment() {
    window.open(this.previewSrc);
  }

}
